import { cportalUserNavigation } from '../utils/menus/cportal_user_navigation_menu';
import { customerAdminLeft } from '../utils/menus/customer_admin_left';
import { everfiAdminLeft } from '../utils/menus/everfi_admin_left';
import { everfiAdminNavigation } from '../utils/menus/everfi_admin_navigation_menu';
import { everfiNextAdminLeft } from '../utils/menus/everfi_next_admin_left';
import { learnerNavigation } from '../utils/menus/learner_navigation_menu';
import { learnerUserNavigation } from '../utils/menus/learner_user_navigation_menu';
import { homeroomTeacherLeft } from '../utils/menus/homeroom_teacher_left';
import { homeroomTeacherNavigation } from '../utils/menus/homeroom_teacher_navigation_menu';
import { homeroomStudentNavigation } from '../utils/menus/homeroom_student_navigation_menu';
import { unauthenticatedCustomerNavigation } from '../utils/menus/unauthenticated_customer_navigation_menu';
import { nextLearnerMenu } from '../utils/menus/next_learner_menu';

export const MENU_SLUG = {
  customerAdminLeft: 'customer_admin_left',
  everfiAdminLeft: 'everfi_admin_left',
  everfiNextAdminLeft: 'everfi_next_admin_left',
  cportalUserNavigation: 'cportal_user_navigation',
  everfiAdminNavigation: 'everfi_admin_navigation',
  learnerNavigationMenu: 'learner_navigation_menu',
  learnerUserNavigationMenu: 'learner_user_navigation',
  homeroomTeacherLeft: 'homeroom_teacher_left',
  homeroomTeacherNavigationMenu: 'homeroom_teacher_navigation',
  homeroomStudentNavigationMenu: 'homeroom_student_navigation',
  unauthenticatedCustomerNavigationMenu: 'unauthenticated_customer_navigation_menu',
  nextLearnerMenu: 'next_learner_menu',
};

export const MENUS = {
  [MENU_SLUG.customerAdminLeft]: customerAdminLeft,
  [MENU_SLUG.everfiAdminLeft]: everfiAdminLeft,
  [MENU_SLUG.everfiNextAdminLeft]: everfiNextAdminLeft,
  [MENU_SLUG.cportalUserNavigation]: cportalUserNavigation,
  [MENU_SLUG.everfiAdminNavigation]: everfiAdminNavigation,
  [MENU_SLUG.learnerNavigationMenu]: learnerNavigation,
  [MENU_SLUG.learnerUserNavigationMenu]: learnerUserNavigation,
  [MENU_SLUG.homeroomTeacherLeft]: homeroomTeacherLeft,
  [MENU_SLUG.homeroomTeacherNavigationMenu]: homeroomTeacherNavigation,
  [MENU_SLUG.homeroomStudentNavigationMenu]: homeroomStudentNavigation,
  [MENU_SLUG.unauthenticatedCustomerNavigationMenu]: unauthenticatedCustomerNavigation,
  [MENU_SLUG.nextLearnerMenu]: nextLearnerMenu,
};

export const PERMITTED_WHITELIST = Object.freeze([
  '/cportal/customizations',
  '/cportal/actionable_dashboard',
  '/cportal/registrations',
]);
